// Retry a blocked sound only after a real interaction, while it is still needed.
export function createAudioPlayback(audio, onBlocked = () => {}, beforePlay = () => {}) {
  let disposed = false, requested = false, pending = false, blocked = false, attempt = 0;
  const setBlocked = value => {
    if (blocked === value) return;
    blocked = value;onBlocked(value);
  };
  const removeListeners = () => {
    window.removeEventListener('pointerdown', retry);
    window.removeEventListener('keydown', retry);
  };
  function retry() {
    if (disposed || !requested || pending) return;
    pending = true;
    const id = ++attempt;
    const failed = error => {
      if (disposed || id !== attempt) return;
      pending = false;
      if (error.name === 'NotAllowedError') {
        setBlocked(true);
        window.addEventListener('pointerdown', retry);
        window.addEventListener('keydown', retry);
      } else if (error.name !== 'AbortError') {
        console.warn('No se pudo reproducir el audio del sorteo:', error.name);
      }
    };
    try {
      beforePlay();
      Promise.resolve(audio.play()).then(() => {
        if (disposed || id !== attempt) return;
        pending = false;
        removeListeners();
        setBlocked(false);
      }, failed);
    } catch (error) { failed(error); }
  }
  function stop() {
    requested = false;pending = false;attempt++;
    removeListeners();audio.pause();
    if (!disposed) setBlocked(false);
  }
  return {
    play() { requested = true;retry(); },
    stop,
    dispose() { disposed = true;stop(); },
  };
}
